export const REST_SERVER = "/api";
export const GOOGLE_MAPS_API_KEY = "AIzaSyDCgJhGeGX2ZaT-A8gSVfyCS-ySsHXCSR0";
